import { LOG, env, getOfferFromURL } from '../helpers';
import { assign as navigate } from '../routes';

export default ({ getUserData }, config = {}) => {
  const nossaLoader = window.NossaLoader({
    url: new URL(
      env() !== 'production'
        ? 'https://identificacao-hlg.clicrbs.com.br'
        : 'https://identificacao.clicrbs.com.br'
    ),
    iframeConfig: {
      standalone: true,
      height: 660
    },
    product: 'degustacao',
    offerId: getOfferFromURL(),
    onAppReady: () => {
      LOG('[NOSSA] Nossa app ready!');
    },
    route: config.route || '',

    onLoginSuccess: user => {
      LOG('[NOSSA] Login sucess!', user.authentication.action, user);
      // Make nossa component fade-out effect
      document
        .querySelector('[data-nossa-loader-standalone]')
        .classList.add('nossa-hidden');
      getUserData(user.userInfo, user.authentication);
    },

    onLogoutSuccess: () => {
      LOG('[[NOSSA] Nossa logout sucess!');
      // Make nossa component fade-in effect
      document
        .querySelector('[data-nossa-loader-standalone]')
        .classList.remove('nossa-hidden');

      // Navigate back to the identify page
      navigate('/identifique-se');

      if (window.isRecoveringAccount) {
        window.isRecoveringAccount = false;
        window.nossaContainer.redirectAfterLogout(
          '/identifique-se/recuperar-cpf'
        );
      }
    }
  });

  return nossaLoader;
};
